var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._t("default", null, {
    "busy": _vm.busy
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }